import { Component, Input } from '@angular/core';

@Component({
  selector: 'document-list',
  templateUrl: './document-list.component.html',
  styleUrls: ['./document-list.component.scss']
})
export class DocumentListComponent {
  @Input() attachments: any[] = [];

  viewDoc(doc: any) {
    window.open(doc.url, '_blank');
  }

  downloadDoc(doc: any) {
    window.open(doc.url, '_blank');
  }

  downloadAll() {
    if (this.attachments) {
      this.attachments.forEach((doc: any) => {
        window.open(doc.url, '_blank');
      });
    }
  }

  getFileIcon(doc: any): string {
    const name: string = doc.name || '';
    const ext = (doc.extension || (name.includes('.') ? name.split('.').pop() : '') || '').toLowerCase();
    switch (ext) {
      case 'pdf': return 'picture_as_pdf';
      case 'xls':
      case 'xlsx':
      case 'csv': return 'grid_on';
      case 'doc':
      case 'docx': return 'article';
      case 'ppt':
      case 'pptx': return 'slideshow';
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif': return 'image';
      case 'zip':
      case 'rar': return 'folder_zip';
      default: return 'insert_drive_file';
    }
  }

  getIconColor(doc: any): string {
    const name: string = doc.name || '';
    const ext = (doc.extension || (name.includes('.') ? name.split('.').pop() : '') || '').toLowerCase();
    switch (ext) {
      case 'pdf': return 'text-red-500';
      case 'xls':
      case 'xlsx':
      case 'csv': return 'text-green-500';
      case 'doc':
      case 'docx': return 'text-blue-500';
      case 'ppt':
      case 'pptx': return 'text-orange-500';
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif': return 'text-purple-500';
      case 'zip':
      case 'rar': return 'text-yellow-600';
      default: return 'text-gray-500';
    }
  }

  formatCategory(category: string): string {
    if (!category) return '';
    switch (category) {
      case 'TERMS_AND_CONDITIONS': return 'Terms & Conditions';
      case 'ELIGIBLE_PRODUCT_LIST': return 'Eligible Products';
      default: return category.replace(/_/g, ' ').toLowerCase()
        .replace(/\b\w/g, c => c.toUpperCase());
    }
  }
}
